import React, { useEffect, useRef, useContext } from "react";
import * as echarts from "echarts";
import { ThemeContext } from "../../../../..";

const CATEGORIES = [
  { key: "community_kitchen", label: "Community Kitchen",  openColor: "#0b2d4d", closedColor: "#b0c8e0" },
  { key: "flood_relief",      label: "Flood Relief Camp",  openColor: "#1a4a73", closedColor: "#c8dff2" },
  { key: "animal_shelter",    label: "Animal Shelter",      openColor: "#59b3ff", closedColor: "#bde0ff" },
];

const OpenCloseChart = ({ dataval }) => {
  const chartRef  = useRef(null);
  const { theme } = useContext(ThemeContext);

  const textColor = theme === "light" ? "#0b2d4d" : "#ffffff";
  const dimColor  = theme === "light" ? "#64748b" : "rgba(255,255,255,0.45)";

  useEffect(() => {
    if (!chartRef.current) return;

    const categoryLabels = CATEGORIES.map((cat) => cat.label);
    const openData       = CATEGORIES.map((cat) => dataval?.[cat.key]?.open   || 0);
    const closedData     = CATEGORIES.map((cat) => dataval?.[cat.key]?.closed || 0);
    const openColors     = CATEGORIES.map((cat) => cat.openColor);
    const closedColors   = CATEGORIES.map((cat) => cat.closedColor);

    const option = {
      backgroundColor: "transparent",
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
        confine: true,
        backgroundColor: "rgba(11,45,77,0.92)",
        borderColor: "transparent",
        textStyle: { color: "#fff", fontSize: 11 },
        borderRadius: 8,
      },
      legend: {
        bottom: 0,
        left: "center",
        itemWidth: 8,
        itemHeight: 8,
        itemGap: 14,
        textStyle: {
          fontSize: 9,
          color: dimColor,
          fontWeight: 500,
        },
        data: [
          { name: "Open",   icon: "circle" },
          { name: "Closed", icon: "circle" },
        ],
      },
      grid: {
        left: 8,
        right: 16,
        top: "15%",
        bottom: "20%",
        containLabel: true,
      },
      xAxis: {
        type: "value",
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: {
          lineStyle: {
            color: theme === "light" ? "#e8f0fe" : "rgba(255,255,255,0.08)",
            type: "dashed",
          },
        },
        axisLabel: {
          fontSize: 8,
          color: dimColor,
        },
      },
      yAxis: {
        type: "category",
        data: categoryLabels,
        inverse: true,
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: {
          fontSize: 9,
          color: textColor,
          fontWeight: 600,
          margin: 8,
          width: 80,
          overflow: "break",
        },
      },
      series: [
        {
          name: "Open",
          type: "bar",
          stack: "total",
          barWidth: 22,
          barCategoryGap: "15%",
          itemStyle: {
            borderRadius: [0, 0, 0, 0],
            color: (params) => openColors[params.dataIndex],
          },
          data: openData,
        },
        {
          name: "Closed",
          type: "bar",
          stack: "total",
          barWidth: 22,
          itemStyle: {
            borderRadius: [0, 4, 4, 0],
            color: (params) => closedColors[params.dataIndex],
          },
          data: closedData,
        },
      ],
    };

    const chart = echarts.init(chartRef.current);
    chart.setOption(option);

    const resize = () => chart.resize();
    window.addEventListener("resize", resize);

    return () => {
      window.removeEventListener("resize", resize);
      chart.dispose();
    };
  }, [dataval, theme]);

  return (
    <div className="card" style={{ width: "100%", height: "95%" }}>
      <div className="card-body" style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        padding: "0.8rem 1rem",
      }}>
        <div className="card-title" style={{ color: "#0b2d4d", marginBottom: "0.4rem" }}>
          <span className="card-title-icon">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="white">
              <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>
            </svg>
          </span>
          Open vs Closed
        </div>

        {/* Horizontal bar chart */}
        <div ref={chartRef} style={{ flex: 1, minHeight: 0 }} />
      </div>
    </div>
  );
};

export default OpenCloseChart;